import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './router';
import axios from 'axios';
import Template from '@/layouts/Template.vue';

Vue.use(VueRouter);

const router = new VueRouter({
    routes
});

// 登陆页面路由 name
const LOGIN_PAGE_NAME = 'login';

// 用来获取后台拿到的路由
var getRouter;

// 跳转之前
router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('loginToken');
    if (!token && to.name !== LOGIN_PAGE_NAME) {
        // 未登录且要跳转的页面不是登录页
        next({
            name: LOGIN_PAGE_NAME // 跳转到登录页
        });
    } else if (!token && to.name === LOGIN_PAGE_NAME) {
        // 未登陆且要跳转的页面是登录页
        next(); // 跳转
    } else {
        if (token) {
            if (!getRouter) {
                if (!getObjArr('VUEMenuRouter')) {
                    axios.post('/menu/getByUsername', { username: localStorage.getItem('CMSUserName') }).then(res => {
                        if (res.data === null) {
                            localStorage.removeItem('loginToken');
                            next({
                                name: LOGIN_PAGE_NAME
                            });
                            return;
                        }
                        getRouter = res.data.children;
                        // saveObjArr('VUEMenuRouter', getRouter); // 存储路由到localStorage
                        routerGo(to, next); // 执行路由跳转方法
                    });
                } else {
                    getRouter = getObjArr('VUEMenuRouter');// 拿到路由
                    routerGo(to, next);
                }
            } else {
                next();
            }
        } else {
            next({
                name: LOGIN_PAGE_NAME
            });
        }
    }
    next();
    // else if (token && to.name === LOGIN_PAGE_NAME) {
    //     // 已登录且要跳转的页面是登录页
    //     next({
    //         name: 'index' // 跳转到 index 页
    //     });
    // }
});

function filterAsyncRouter(asyncRouterMap) { //  遍历后台传来的路由字符串，转换为组件对象
    const accessedRouters = asyncRouterMap.filter(route => {
        route.name = route.title;
        if (route.href === '' || route.href === null) {
            route.component = Template;
            route.path = '/';
        } else {
            if (route.href.toLowerCase().indexOf('/industrynews/') === -1) {
                route.component = () => import(/* webpackChunkName: "about" */ '../views' + route.href + '.vue');
                const paths = route.href.split('/');
                route.path = '/' + paths[paths.length - 1];
            } else {
                route.component = () => import(/* webpackChunkName: "about" */ '../views/industryNews/newsList.vue');
                route.meta = { id: route.id };
                const paths = route.href.split('/');
                route.path = '/industryNews/' + paths[paths.length - 1];
            }
        }
        if (route.hasChild && route.children.length) {
            route.children = filterAsyncRouter(route.children);
        }
        return true;
    });
    return accessedRouters;
}

// 行业动态href /IndustryNews/newestDynamics

function routerGo(to, next) {
    getRouter = filterAsyncRouter(getRouter); // 过滤路由
    getRouter.push({
        path: '*',
        name: '首页',
        component: Template,
        hidden: true
    });
    router.addRoutes(getRouter); // 动态添加路由
    global.antRouter = getRouter; // 将路由数据传递给全局变量，做侧边栏菜单渲染工作
    next({ ...to, replace: true });
}

// function saveObjArr(name, data) { // localStorage 存储数组对象的方法
//     localStorage.setItem(name, JSON.stringify(data));
// }

function getObjArr(name) { // localStorage 获取数组对象的方法
    return JSON.parse(window.localStorage.getItem(name));
}

// 跳转之后
router.afterEach(to => {
    // TODO
});

export default router;
